import { IoCalendarOutline, IoTicketOutline, IoCard, IoSettingsOutline, IoDocumentOutline } from "react-icons/io5";

export type TabType = "reservations" | "tickets" | "ecard" | "settings" | "documents";

export interface TabConfig {
  id: TabType;
  desktopLabel: string;
  mobileLabel: string;
  requiresConfig?: string; // konfiguracyjny klucz do sprawdzenia
  icon: React.ReactNode;
}

export const TABS_CONFIG: TabConfig[] = [
  {
    id: "reservations",
    desktopLabel: "Twoje rezerwacje",
    mobileLabel: "Rezerwacje",
    icon: IoCalendarOutline,
  },
  {
    id: "tickets",
    desktopLabel: "Twoje bilety i karnety",
    mobileLabel: "Bilety/karnety",
    icon: IoTicketOutline,
  },
  {
    id: "ecard",
    desktopLabel: "Twoja eKarta",
    mobileLabel: "eKarta",
    requiresConfig: "ecard_showCode",
    icon: IoCard,
  },
  {
    id: "documents",
    desktopLabel: "Twoje dokumenty",
    mobileLabel: "Dokumenty",
    icon: IoDocumentOutline,
  },
  {
    id: "settings",
    desktopLabel: "Ustawienia konta",
    mobileLabel: "Ustawienia",
    icon: IoSettingsOutline,
  },
];
